import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../config/Urls";
import Storage from "../utils/HandelLocalStorage";

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 18000,
  params: {},
});

// instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// instance.defaults.headers.post['Content-Type'] = 'application/json';

// Add a request interceptor
instance.interceptors.request.use(
  async function (config) {
    let token = "";
    try {
      const params = await Storage.retrieveItem("userDetails");
      if (params) {
        const userDetails = JSON.parse(params);
        token = userDetails?.token;
      }
    } catch (error) {
      console.log("Error retrieving token:", error);
    }

    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    console.log("error from interceptor request", error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // console.log('++++++++++Response Config++++++++++', response);
    return response;
  },
  function (error) {
    console.log("error from interceptor response", error);
    if (error.response.status === 400) {
      toast.error(error.response.data.message);
    } else {
      toast.error(error.response.data.message);
    }
    return Promise.reject(error);
    // if (error) return error;
  }
);


export default instance;
